import { FieldSet, Field } from 'common/components/Form';
import { FormattedMessage } from 'react-intl';
import { Select } from '@99designs/common/components/Select';
import { handleUpdatedAttribute } from 'book-calculator/actions/handleUpdatedAttribute';
import BookCalculatorAttributesStore from 'book-calculator/stores/BookCalculatorAttributesStore';
import BookCalculatorFieldOptionStore from 'book-calculator/stores/BookCalculatorFieldOptionStore';
import PropTypes from 'prop-types';
import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';

class BasicsFieldset extends React.Component {
    handleUpdateAttribute(key, value) {
        this.context.executeAction(handleUpdatedAttribute, {
            key: key,
            value: value,
        });
    }

    render() {
        const { bookType, bookTypeOptions, genre, genreOptions } = this.props;

        return (
            <FieldSet twoColumn={false}>
                <div className="row">
                    <div className="column small-12 medium-6 normal-6 large-6">
                        <Field
                            title={<FormattedMessage id="fields.type.label" />}
                            variations={['jumbo-title']}
                        >
                            <Select
                                onChange={({ value }) => {
                                    this.handleUpdateAttribute('book_type', value);
                                }}
                                name={'type'}
                                value={bookType}
                                options={bookTypeOptions}
                            />
                        </Field>
                    </div>
                    <div className="column small-12 medium-6 normal-6 large-6">
                        <Field
                            title={<FormattedMessage id="fields.genre.label" />}
                            variations={['jumbo-title']}
                        >
                            <Select
                                onChange={({ value }) => {
                                    this.handleUpdateAttribute('genre', value);
                                }}
                                name={'genre'}
                                variations={['max']}
                                value={genre}
                                options={genreOptions}
                            />
                        </Field>
                    </div>
                </div>
            </FieldSet>
        );
    }
}

BasicsFieldset.contextTypes = {
    executeAction: PropTypes.func.isRequired,
};

BasicsFieldset.propTypes = {
    bookType: PropTypes.string.isRequired,
    bookTypeOptions: PropTypes.array.isRequired,
    genre: PropTypes.string.isRequired,
    genreOptions: PropTypes.array.isRequired,
};

export default connectToStores(BasicsFieldset, [BookCalculatorAttributesStore], (context, prop) => {
    const attributes = context.getStore(BookCalculatorAttributesStore).getState();
    const options = context.getStore(BookCalculatorFieldOptionStore).getOptions();

    return {
        bookType: attributes['book_type'],
        bookTypeOptions: options['book_type'],
        genre: attributes['genre'],
        genreOptions: options['genre'],
    };
});
